/**
 * O que uma tela deixa para o login ao mandar alguém entrar: com que e-mail e por quê.
 *
 * Viaja no estado da rota (`nav.replace`), não na URL: o e-mail é dado pessoal e não precisa
 * ficar no histórico do navegador nem num link compartilhável.
 */

export interface LoginHandoff {
  /** E-mail para preencher o campo; vazio deixa o login como sempre. */
  email: string;
  /** Aviso a mostrar acima do formulário; vazio não mostra nada. */
  notice: string;
}

export const INVITATION_ACCEPTED_NOTICE = 'Convite aceito. Entre com a sua senha.';

function stringAt(state: object, key: 'email' | 'notice'): string {
  if (!(key in state)) return '';
  const value = Reflect.get(state, key);
  return typeof value === 'string' ? value : '';
}

/**
 * Lê o estado da rota do login. Qualquer outra coisa (`undefined`, um estado de outra tela,
 * uma entrada de histórico restaurada) devolve `null`, e o login abre no estado normal.
 */
export function loginHandoffOf(state: unknown): LoginHandoff | null {
  if (typeof state !== 'object' || state === null) return null;
  const handoff = { email: stringAt(state, 'email'), notice: stringAt(state, 'notice') };
  return handoff.email || handoff.notice ? handoff : null;
}
